var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Vector","d":"M3.90018 2.54539C3.89984 3.29632 3.44426 3.97208 2.74825 4.254C2.05225 4.53592 1.25481 4.36772 0.731967 3.82871C0.20912 3.28968 0.0652792 2.48749 0.368261 1.8004C0.671251 1.1133 1.36056 0.678502 2.11116 0.701031C3.1081 0.730955 3.90063 1.548 3.90018 2.54539ZM3.95551 5.75456H0.266802V17.3002H3.95551V5.75456ZM9.78369 5.75456H6.11341V17.3002H9.7468V11.2415C9.7468 7.86632 14.1456 7.55278 14.1456 11.2415V17.3002H17.7882V9.98733C17.7882 4.29752 11.2776 4.50962 9.7468 7.30379L9.78369 5.75456Z","fill":"#FCFCFC"}));
}

Linkedin.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
